module.exports = __webpack_public_path__ + "img/icn_password.57e4eee6.svg";